import type { CarrierInitializationDiscoveryProgress } from '@/services/api';

export interface CarrierDiscoveryPresentation {
  phaseLabel: string;
  statusLabel: string;
  description: string;
  actionLabel: string | null;
}

export function getCarrierDiscoveryPresentation(
  progress: CarrierInitializationDiscoveryProgress | null
): CarrierDiscoveryPresentation {
  if (!progress) {
    return {
      phaseLabel: 'Find carrier data',
      statusLabel: 'Not started',
      description: 'Start with the accounts connected to this tenant.',
      actionLabel: 'Find carrier data',
    };
  }

  if (progress.complete || progress.phase === 'complete') {
    return {
      phaseLabel: 'Ready to review',
      statusLabel: progress.truncated ? 'Some results may be missing' : 'Complete',
      description: 'Review what was found before continuing setup.',
      actionLabel: null,
    };
  }

  const customerPhase = progress.phase === 'account_discovery';
  const phaseName = customerPhase ? 'accounts' : 'carriers';
  const statusLabel = progress.status === 'rate_limited'
    ? 'Paused'
    : progress.status === 'progress'
      ? 'In progress'
      : 'Ready';
  const description = progress.status === 'rate_limited'
    ? 'The search paused, but your progress is saved.'
    : `Review what is here or continue finding ${phaseName}.`;

  return {
    phaseLabel: customerPhase ? 'Finding accounts' : 'Finding carriers',
    statusLabel,
    description,
    actionLabel: progress.status === 'rate_limited' ? 'Resume search' : 'Continue search',
  };
}
